import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EditComponent } from './edit/edit.component';
import { PersonalComponent } from './personal/personal.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DragulaModule } from 'ng2-dragula';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { DemoMaterialModule } from '../../demo-material-module';
import {MortgageComponent} from '../mortgage/mortgage.component';
import { SharedModule } from '../shared.module';
import { DialerReportComponent } from '../dialer-report/dialer-report.component';
import { DialerDispositionComponent } from '../dialer-disposition/dialer-disposition.component';
import { ScriptComponent } from './script/script.component';
import { CommentComponent } from './comment/comment.component';
import { ContactSearchPipe } from '../leadlist/keypipe/searchpipe';
import { QuillModule } from 'ngx-quill';
import { SearchInsuranceComponent } from './search-insurance/search-insurance.component';
import {MatDialogModule} from '@angular/material/dialog';
import { SearchComponent } from './search/search.component';
import { BuildchartComponent } from './buildchart/buildchart.component';

@NgModule({
  imports: [
    CommonModule,
    DemoMaterialModule,
    FormsModule,
    CommonModule,
    FlexLayoutModule,
    ReactiveFormsModule,
    DragulaModule,
    NgbModule,
    QuillModule,
    MatDialogModule
    
  ],
  declarations: [CommentComponent, EditComponent, PersonalComponent, ScriptComponent , MortgageComponent, DialerReportComponent,DialerDispositionComponent,ContactSearchPipe, SearchInsuranceComponent, SearchComponent, BuildchartComponent],
  exports: [CommentComponent, EditComponent, PersonalComponent, ScriptComponent , MortgageComponent,  DialerReportComponent, DialerDispositionComponent,ContactSearchPipe ] ,
  entryComponents: [
    SearchInsuranceComponent, BuildchartComponent, SearchComponent
  ],
})
export class MortgageModule { }


